import { Dayjs } from 'dayjs'

import { day } from './day'

const isStringWithContent = (value: unknown): value is string => typeof value === 'string' && value.trim() !== ''

/**
 * Configuration for getNow. Set mockedNow to override the current date.
 * Useful for testing or when VITE_TODAY environment variable should be respected.
 */
export const getNowConfig: { mockedNow?: string } = {}

/**
 * Retrieves the current date using the Dayjs library.
 * It first checks if mockedNow is set in getNowConfig,
 * and if so, uses it to create a new instance of Dayjs.
 * If mockedNow is not set or is invalid,
 * it falls back to creating a new instance based on the current system date.
 *
 * @returns {Dayjs} - The current date as an instance of Dayjs.
 */
export const getNow = (): Dayjs => {
    const mockedNow = getNowConfig.mockedNow

    if (isStringWithContent(mockedNow)) {
        const configToday = day(mockedNow)

        if (configToday.isValid()) {
            return configToday
        }

        console.warn(`getNowConfig.mockedNow is set to an invalid date: ${mockedNow}. Using the current system date instead.`)
    }

    return day(new Date())
}
